export const BUFFER_MARKETING_URL = 'https://buffer.com'
export const GUEST_RETURN_PARAM = 'return_to'

const MARKETING_HOSTS = new Set(['buffer.com', 'www.buffer.com'])
const STORAGE_KEY = 'buffer-guest-return-url'

function toMarketingUrl(candidate: string | null | undefined): string | null {
  if (!candidate) return null
  let url: URL
  try {
    url = new URL(candidate, BUFFER_MARKETING_URL)
  } catch {
    return null
  }
  if (url.protocol !== 'https:' || !MARKETING_HOSTS.has(url.hostname)) {
    return null
  }
  if (url.username || url.password || url.port) return null
  return url.href
}

function readStored(): string | null {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

function store(value: string): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, value)
  } catch {
    return
  }
}

export function resolveGuestReturnUrl({
  search = window.location.search,
  referrer = document.referrer,
}: { search?: string; referrer?: string } = {}): string {
  const fromParam = toMarketingUrl(
    new URLSearchParams(search).get(GUEST_RETURN_PARAM),
  )
  const fromReferrer = toMarketingUrl(referrer || null)
  const arrival = fromParam ?? fromReferrer
  if (arrival) {
    store(arrival)
    return arrival
  }
  return toMarketingUrl(readStored()) ?? BUFFER_MARKETING_URL
}
